import { ReactComponent as Loading } from "app/assets/svg/loading.svg"
import { StyledLoadingIcon } from "./style"

const LoadingIndicator: React.FC = props => {
  return <StyledLoadingIcon {...props} component={Loading} />
}

export default LoadingIndicator
